import React from "react";
import LocationItemLink from "./LocationItemLink";
import {styled} from "@mui/material/styles";

const ReclocationItemLink = styled(LocationItemLink)(({theme}) => ({
  maxWidth: '75%',
  [theme.breakpoints.up('md')]: {
    maxWidth: '25%',
  }
}));

const RecentlyBookedLocationItem = (props) => {
    const {location} = props;

    const {listingImageFileName, pricePerDay, pricePerMonth, hasInstantApproval, locationName, cityName, id} = location;

    return (
        <ReclocationItemLink
            listingImageFileName={listingImageFileName}
            pricePerDay={pricePerDay}
            pricePerMonth={pricePerMonth}
            instantApproval={hasInstantApproval}
            locationName={locationName}
            cityName={cityName}
            href={`/location-profile/${id}`}
            target={'_blank'}
        />
    )
}

export default RecentlyBookedLocationItem;
